import script from "./FooterBar.vue?vue&type=script&setup=true&lang=ts"
export * from "./FooterBar.vue?vue&type=script&setup=true&lang=ts"

import "./FooterBar.vue?vue&type=style&index=0&id=f693827a&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f693827a"]])

export default __exports__